import styled, { css } from "styled-components";
import { colors, darkModeColors } from "../../consts";
import { FlexContainers, WrapperContainer } from "../../components";

export const InputContainer = styled(FlexContainers.FlexColumnStart)`
  width: 100%;

  &.error {
    label {
      color: ${colors.ERROR};
    }

    input, textarea {
      border: 1px solid ${colors.ERROR};

      &:focus {
        border: 2px solid ${colors.ERROR};
      }
    }
  }
`;

export const InputTitleWrapper = styled(FlexContainers.FlexRowStart)`
  width: 100%;
  gap: 4px;
  margin-bottom: 8px;
  align-items: baseline;

  & label {
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;

    color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_100)};
  }

  & span {
    color: ${colors.ERROR};
  }

  & p {
    font-size: 12px;
    line-height: 18px;
    color: ${colors.RAISIN_80};
  }

  & svg {
    cursor: pointer;
  }
`;

export const IconWrapper = styled(FlexContainers.FlexColumnCenter)`
  height: 48px;
  position: absolute;
  right: 12px;
`;

export const InputStyles = css`
  background: ${darkModeColors.WHITE_RAISIN_100};
  border: 1px solid ${colors.RAISIN_50};
  border-radius: 8px;

  height: ${(props) => (props.isSmall ? "40px" : "48px")};
  width: 100%;
  padding: 0 12px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${darkModeColors.RAISIN_100_WHITE};
  overflow-x: auto;

  ${(props) => props.hasIcon && `padding-right: 25px;`};

  &:hover {
    box-shadow: ${(props) =>
      props?.theme?.darkMode
        ? `0px 4px 4px rgba(255, 255, 255, 0.16)`
        : `0px 4px 4px rgba(52, 48, 61, 0.16)`};
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border: ${(props) =>
      props?.theme?.darkMode
        ? `2px solid ${colors.TURQUOISE_100}`
        : `2px solid ${colors.RAISIN_100}`};
  }

  &::placeholder {
    color: ${colors.RAISIN_50};
  }

  &:disabled {
    pointer-events: none;
    background: ${colors.ISABELLINE_DARKER};
    color: ${colors.RAISIN_50};
    border: none;

    &::-moz-selection {
      color: inherit;
      background: transparent;
    }

    &::selection {
      color: inherit;
      background: transparent;
    }
  }
`;

export const TextareaStyles = css`
  min-height: 50px;
  resize: none;
  padding: 12px;
  line-height: 22px;
`;

export const InputWrapper = styled(FlexContainers.FlexRowEnd)`
  position: relative;
  width: 100%;

  * {
    transition: all 0.2s ease-in;
  }

  input,
  textarea {
    ${InputStyles}
  }

  textarea {
    ${TextareaStyles}
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: ${darkModeColors.RAISIN_100_WHITE};
    -webkit-box-shadow: 0 0 0px 48px ${darkModeColors.WHITE_RAISIN_100} inset;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  svg {
    cursor: pointer;
  }
`;

export const InputComponentWrapper = styled(WrapperContainer)`
  ${InputStyles} {
    padding-top: 7px;
    padding-bottom: 7px;

    min-height: 48px;
    height: fit-content;
  }
`;
